import type { ComponentProps } from 'react';

const AvatarFather = (props: ComponentProps<'svg'>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31.9998 61.3332C48.2002 61.3332 61.3332 48.2002 61.3332 31.9998C61.3332 15.7995 48.2002 2.6665 31.9998 2.6665C15.7995 2.6665 2.6665 15.7995 2.6665 31.9998C2.6665 48.2002 15.7995 61.3332 31.9998 61.3332Z"
      fill="#ECF7F6"
    />
    <mask
      id="mask0_208_43506"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="60"
      height="60"
    >
      <path
        d="M31.9998 61.3332C48.2002 61.3332 61.3332 48.2002 61.3332 31.9998C61.3332 15.7995 48.2002 2.6665 31.9998 2.6665C15.7995 2.6665 2.6665 15.7995 2.6665 31.9998C2.6665 48.2002 15.7995 61.3332 31.9998 61.3332Z"
        fill="#ECF7F6"
      />
    </mask>
    <g mask="url(#mask0_208_43506)">
      <path
        d="M19.6957 46.7605L45.2803 46.6354C50.2242 46.6113 54.9752 48.5521 58.4881 52.0308C62.0011 55.5096 63.9882 60.2415 64.0124 65.1854L64.1322 89.7049L1.26561 90.0121L1.14573 65.4807C1.12473 60.5388 3.06693 55.7909 6.54538 52.2805C10.0238 48.7701 14.7539 46.7846 19.6957 46.7605Z"
        fill="#E06257"
      />
      <path
        d="M35.2646 11.5274L30.7724 11.5149C25.5147 11.5002 21.2405 15.7505 21.2259 21.0082L21.1915 33.3127C21.1768 38.5704 25.4271 42.8445 30.6848 42.8592L35.177 42.8717C40.4347 42.8864 44.7088 38.6361 44.7235 33.3784L44.7579 21.0739C44.7726 15.8162 40.5223 11.5421 35.2646 11.5274Z"
        fill="#FFBF9F"
      />
      <path
        d="M44.7443 27.9062V22.2418C44.786 20.1117 44.7443 18.529 43.3461 16.0776C43.3461 16.0776 40.7816 17.4699 41.1803 21.3553C41.5194 24.5325 44.7443 27.9062 44.7443 27.9062Z"
        fill="#5B1D1E"
      />
      <path
        d="M21.2069 30.9287V22.1703C21.0198 20.0833 21.4855 17.9897 22.5397 16.1787C22.5397 16.1787 27.6626 19.5345 24.4199 25.2286L21.2069 30.9287Z"
        fill="#5B1D1E"
      />
      <path
        d="M20.523 33.1422C22.3665 33.1422 23.8609 31.6477 23.8609 29.8042C23.8609 27.9608 22.3665 26.4663 20.523 26.4663C18.6795 26.4663 17.1851 27.9608 17.1851 29.8042C17.1851 31.6477 18.6795 33.1422 20.523 33.1422Z"
        fill="#FFBF9F"
      />
      <path
        d="M45.5122 31.6842C47.3557 31.6842 48.8502 30.1897 48.8502 28.3462C48.8502 26.5027 47.3557 25.0083 45.5122 25.0083C43.6688 25.0083 42.1743 26.5027 42.1743 28.3462C42.1743 30.1897 43.6688 31.6842 45.5122 31.6842Z"
        fill="#FFBF9F"
      />
      <path
        d="M28.6387 30.7787C29.305 30.7462 29.8038 29.8711 29.7528 28.8241C29.7017 27.7771 29.1203 26.9546 28.454 26.9871C27.7877 27.0196 27.2889 27.8947 27.3399 28.9417C27.391 29.9887 27.9725 30.8112 28.6387 30.7787Z"
        fill="#5B1D1E"
      />
      <path
        d="M40.7325 30.1844C41.3988 30.152 41.8975 29.2769 41.8465 28.2299C41.7955 27.1828 41.214 26.3604 40.5477 26.3929C39.8814 26.4253 39.3827 27.3004 39.4337 28.3474C39.4847 29.3945 40.0662 30.2169 40.7325 30.1844Z"
        fill="#5B1D1E"
      />
      <path
        d="M32.684 36.4976C32.2158 36.4921 31.7583 36.3561 31.3631 36.1049C30.9938 35.8962 30.6915 35.5869 30.4913 35.2129C30.2911 34.8389 30.2014 34.4157 30.2326 33.9927L31.4226 34.0522C31.4058 34.2654 31.4535 34.4788 31.5596 34.6645C31.6658 34.8502 31.8253 34.9997 32.0176 35.0934C32.2225 35.2451 32.4707 35.327 32.7257 35.327C32.9806 35.327 33.2288 35.2451 33.4337 35.0934L34.0942 36.0871C33.6773 36.3652 33.185 36.5085 32.684 36.4976Z"
        fill="#5B1D1E"
      />
      <path
        d="M35.5796 33.3742L34.9846 32.3508C35.3535 32.1307 36.4186 31.3572 36.6685 30.6313C36.2838 30.6384 35.9025 30.7046 35.538 30.8276C35.4463 30.8577 35.3486 30.8649 35.2535 30.8488C35.1583 30.8327 35.0685 30.7937 34.9918 30.7351C34.9151 30.6766 34.8537 30.6002 34.8131 30.5127C34.7725 30.4251 34.7538 30.329 34.7585 30.2326L34.824 25.4727H36.014L35.9604 29.4591C36.2337 29.3802 36.5211 29.3628 36.8019 29.408C37.0828 29.4533 37.3501 29.5602 37.5848 29.7209C37.7253 29.8589 37.8243 30.0335 37.8706 30.2249C37.9169 30.4163 37.9086 30.6169 37.8466 30.8038C37.4836 32.208 35.776 33.2552 35.5796 33.3742Z"
        fill="#5B1D1E"
      />
      <path
        d="M33.8091 58.4653C33.6513 58.4653 33.5 58.4026 33.3884 58.2911C33.2768 58.1795 33.2141 58.0281 33.2141 57.8703L33.1665 46.6963H34.3565L34.3981 57.2753L37.51 57.192L37.5457 58.382L33.821 58.4832L33.8091 58.4653Z"
        fill="#F58D7A"
      />
      <path
        d="M36.7065 56.0752C37.2508 56.0392 37.6484 55.3508 37.5945 54.5376C37.5406 53.7244 37.0557 53.0945 36.5114 53.1305C35.9671 53.1666 35.5695 53.855 35.6234 54.6682C35.6773 55.4813 36.1622 56.1113 36.7065 56.0752Z"
        fill="#F58D7A"
      />
    </g>
  </svg>
);

export default AvatarFather;
